export const RULES = {
  RULE0001: "RULE0001", //	Sözleşme tipi lojman kira sözleşmesi ise
  RULE0002: "RULE0002", //	Muhattap ekranı Muhattap tipi Lojman Kiracısı ise
  RULE0003: "RULE0003", //	Muhattap ekranı Muhattap tipi Kreş Öğrencisi ise
  RULE0004: "RULE0004", //	Muhattap ekranı Muhattap tipi Veli ise
  RULE0005: "RULE0005", //	Kiralabilir alan ekranı, kiralanabilir alan türü lojman ise
  RULE0006: "RULE0006", //	Sözleşme hatırlatma tipi bitiş tarihi seçilmişse
  RULE0007: "RULE0007", //	Koşul Amacı tek seferlik ise
  RULE0008: "RULE0008", //	Koşul Tipi Kreş Koşulu
  RULE0009: "RULE0009", //	Tapu Cinsi, Tapuda Kayıtlı Olan Taşınmazlar
  RULE0010: "RULE0010", //	Tapu Cinsi, Tapuda Kayıtlı Olmayan Taşınmazlar
  RULE0011: "RULE0011", //	Tapu Cinsi Orta Malları
  RULE0012: "RULE0012", //	Tapu Cinsi Genel Hizmet Alanları
  RULE0013: "RULE0013", //	Tapu Cinsi Sınırlı Ayni Haklar İle Kişisel Haklar Ve Tahsis
  RULE0014: "RULE0014", //	Sözleşme Tipi, Kreş Sözleşmesi
  RULE0015: "RULE0015", //	Kiralanabilir alan türü kreş ise
  RULE0017: "RULE0017", //	Muhattap ekranı Muhattap tipi Kiracı ise
  RULE0018: "RULE0018", //  Muhattap ekranı Muhattap tipi Lojman Kiracı Adayı ise
  RULE0019: "RULE0019", //  Kullanıcı Grubu önceden tanımlı ise
  RULE0020: "RULE0020", //  Kullanıcı Grubu önceden tanımlı ve admin ise
  RULE0021: "RULE0021", //  Muhattap ekranı Muhattap tipi Sahibi ise
  RULE0022: "RULE0022", //  Koşul tipi Kira Bedeli ise
  RULE0023: "RULE0023", //  Kullanıcı Grubu önceden tanımlı ve super admin ise
};
